import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RESET_REDUX_STORE } from 'src/app/shared/constants/actionTypes';
import sendLinkEventWithState from 'src/app/utils/analytics/sendLinkEventWithState';
import { getQueryParams } from 'src/app/utils/queryParams';
import * as reducers from 'src/app/v1/state/modules';

export const configureClientStore = () => {
  // any state that is being persisted can be reset via a store util
  // using the `UTILS_RESET_PERSISTENT_DATA` action
  const persistConfig = {
    key: 'seek_caja_express:store',
    storage,
    whitelist: ['formData', 'session', 'tealium'],
  };

  const appPersistConfig = {
    key: 'seek_caja_express:store:app',
    storage,
    whitelist: ['progress'],
  };

  const appReducer = combineReducers({
    ...reducers,
    app: persistReducer(appPersistConfig, reducers.app),
  });

  const rootReducer = (state: any, action: any) => {
    if (action.type === RESET_REDUX_STORE) {
      return appReducer(undefined, action);
    } else if (action.type === 'TRACK_ERROR') {
      const currentTealiumState = state?.tealium || {};
      // TODO: we need to update this event to start using new tracker
      sendLinkEventWithState(currentTealiumState, action.payload);
      return appReducer(state, action);
    }
    return appReducer(state, action);
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const preloadedState = {
    app: {
      queryParams: getQueryParams(),
    },
  };

  const store = configureStore({
    reducer: persistedReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  });
  persistStore(store);

  return store;
};
